import React from 'react'
import Layout from '../components/Layout'

function _404() {
  return (
    <Layout>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          textAlign: 'center',
          paddingTop: 150,
        }}
      >
        <h1
          style={{
            fontSize: 158,
            color: '#b79a5e',
          }}
        >
          404
        </h1>

        <p
          style={{
            fontSize: 32,
            color: '#c9c9c9',
          }}
        >
          A página que você procura não existe.
        </p>
      </div>
    </Layout>
  )
}

export default _404
